import { render, staticRenderFns } from "./mdc-list-item-text.vue?vue&type=template&id=626205d6&"
import script from "./mdc-list-item-text.vue?vue&type=script&lang=ts&"
export * from "./mdc-list-item-text.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports